import React from 'react'
import PropTypes from 'prop-types'
import { DemoCTA, Link, StartTrialButtonWithModal } from 'newComponents'
import { track } from '../utils/thirdPartyUtils'

const handleDemoLinkClick = () => {
  track('Request Demo Button Clicked')
}

const ClosingCTA = ({ title, subtitle }) => (
  <section className="section is-large bg-gradient">
    <div className="container content has-text-centered-tablet">
      <h2 className="title">{title}</h2>
      <p className="subtitle">{subtitle}</p>
      <div className="columns is-centered">
        <div className="column is-narrow">
          <DemoCTA primaryCta />
        </div>
        <div className="column is-narrow">
          <DemoCTA outlineCta to="/contact-sales/" text="Contact Sales" eventName="Contact Sales Button Clicked" />
        </div>
      </div>
    </div>
  </section>
)

ClosingCTA.defaultProps = {
  title: 'Ready to Get Started?',
  subtitle: 'Get started today, and talk to an expert.'
}

ClosingCTA.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default ClosingCTA
